<script setup lang="ts">
import { type User } from '#shared'
import PingsAutocompleteItem from './pings-autocomplete-item.vue'

const { variants, focusedAutocompleteVariantIndex } = defineProps<{
  prefix?: string
  focusedAutocompleteVariantIndex: number
  variants: User[]
}>()

const emit = defineEmits<{ 'autocomplete-variant-focus': [index: number]; 'complete': [login: string] }>()

const onItemHover = (userIndex: number) => {
  emit('autocomplete-variant-focus', userIndex)
}

const onComplete = (login: string) => emit('complete', login)
</script>

<template>
  <ul :class="$style.root">
    <PingsAutocompleteItem
      v-for="(user, userIndex) in variants"
      :key="user.id"
      :user="user"
      :isFocused="userIndex === focusedAutocompleteVariantIndex"
      @hover="onItemHover(userIndex)"
      @complete="onComplete"
    />
  </ul>
</template>

<style lang="scss" module>
@use '../mixins.scss' as *;

.root {
  padding-top: 10px;
  padding-bottom: 10px;
  display: flex;
  flex-direction: column;
  background-color: #1f1c1b;
}

.rootEmpty {
  @include message-editor-padding;
  padding-top: 10px;
  padding-bottom: 10px;
}
</style>
